import { Component, Input } from '@angular/core';

@Component({
  selector: 'cms-crm-field-info-edit',
  templateUrl: './crm-field-info-edit.component.html',
  styleUrls: ['../crm-fields-info-edit.scss']
})
export class CrmFieldInfoEditComponent {

  @Input()
  value: any;

  @Input()
  fieldName = 'This';
}
